module.exports = __webpack_public_path__ + "media/images/games/k2gender/legos-9c2872c25d85d78ea94732b6e1afb199.png";